import { NotificationState } from "../reducers/notification.reducer";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export const Notifications = createFeatureSelector<NotificationState>('notification');
export const getCurrentNotification = createSelector(Notifications,x => x.current);